import { render } from "./row-form.vue?vue&type=template&id=28268375"
import script from "./row-form.vue?vue&type=script&lang=js"
export * from "./row-form.vue?vue&type=script&lang=js"

import "./row-form.vue?vue&type=style&index=0&id=28268375&lang=css"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__